"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const src_1 = __importDefault(require("./src"));
vue_1.default.use(src_1.default, {
    expiredHandler: function (url) {
        const auth = vue_1.default.prototype.$auth;
        if (auth)
            auth.toLogin(url, false);
    },
    requestHandler(cfg) {
        // TODO
    }
});
